import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MaxLocations } from '../../../../shared/types';
import { useAdminMaxLocations } from '../../../hooks/useAdminMaxLocations';
import { MaxLocationForm } from './MaxLocationForm';

export const MaxLocationEdit = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedLocation, setSelectedLocation] = useState<MaxLocations>();
    const { data: maxLocations = [], isFetched } = useAdminMaxLocations();

    useEffect(() => {
        if (!isFetched) return;

        const location = maxLocations.find((location) => location._id.toString() === id!);

        if (location) setSelectedLocation(location);
    }, [id, isFetched]);

    if (!selectedLocation) return null;

    return <MaxLocationForm maxLocation={selectedLocation} />;
};
